<template>
  <ValidationProvider :name="$attrs.name" :rules="rules" v-slot="{ errors }">
    <v-switch v-model="innerValue" v-bind="$attrs" v-on="$listeners" :error-messages="errors">
      <template #append>
        <slot name="append" />
      </template>
      <template #default>
        <slot name="default" />
      </template>
      <template #label>
        <slot name="label" />
      </template>
      <template #message>
        <slot name="message" />
      </template>
      <template #prepend>
        <slot name="prepend" />
      </template>
    </v-switch>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    rules: {
      type: [Object, String],
      default: "",
    },
    value: {
      type: null,
    },
  },
  data: () => ({
    innerValue: "",
  }),
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
    },
  },
  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>

<style>
</style>